import React from 'react'
import { Globe, Clock, TrendingUp } from 'lucide-react'

const Solution: React.FC = () => {
  const solutions = [
    {
      icon: Globe,
      title: "글로벌 모니터링",
      features: ["국내외 유명 커뮤니티", "국내외 유명 IT 리더"],
      color: "text-blue-500"
    },
    {
      icon: Clock,
      title: "5분 완독",
      features: ["핵심 요약", "트렌드 의견 추가"],
      color: "text-green-500"
    }
  ]

  return (
    <section className="py-20 bg-gradient-to-br from-primary-50 to-blue-50">
      <div className="container-width section-padding">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-primary-100 rounded-full mb-8">
            <TrendingUp className="w-10 h-10 text-primary-600" />
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            매주 AI 트렌드 추적
            <br />
            <span className="text-primary-600">핵심 요약</span>
          </h2>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            복잡하고 흩어진 AI 정보를 체계적으로 정리해서
            <br />
            <strong className="text-primary-600">정말 중요한 인사이트만</strong> 전달합니다
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          {solutions.map((solution, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-3xl shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 animate-slide-up"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className={`w-16 h-16 ${solution.color} bg-current/10 rounded-full flex items-center justify-center mb-6`}>
                <solution.icon className={`w-8 h-8 ${solution.color}`} />
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                {solution.title}
              </h3>
              
              <div className="space-y-4">
                {solution.features.map((feature, featureIndex) => (
                  <div key={featureIndex} className="flex items-center gap-3">
                    <div className={`w-2 h-2 ${solution.color} bg-current rounded-full`}></div>
                    <span className="text-gray-700 font-medium">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <div className="inline-block bg-white p-8 rounded-3xl shadow-lg border border-primary-200">
            <h3 className="text-3xl font-bold text-primary-600 mb-4">
              "진짜 AI 최전선을 만나세요"
            </h3>
            <p className="text-lg text-gray-700 max-w-2xl mx-auto leading-relaxed">
              글로벌 AI 커뮤니티에서 일어나는 <strong>실제 혁신</strong>과 
              <strong> 미래를 바꿀 트렌드</strong>를 가장 빠르게 전달받으세요
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Solution
